import { useContext, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { theme } from '../../theme';
import { uploadProfileImage } from '../service';
import { Context } from '../Provider';
import CardTemplate from '../../common/CardTemplate';

const ProfilePhoto = () => {
    const { state: { ftm, step }, updateCurrentStep } = useContext(Context);
    const fileInputRef = useRef(null);

    const [imageSrc, setImageSrc] = useState(ftm?.ftm_profile_image_path || '/assets/img/empty_image.png');
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const triggerFileInput = () => fileInputRef.current?.click();

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];

        if (!file || !file.type.startsWith('image/')) {
            toast.error('Please select a valid image file.');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => setImageSrc(reader.result);
        reader.readAsDataURL(file);

        await handleUpload(file);
    };

    const handleUpload = async (file) => {
        try {
            setUploading(true);
            setUploadProgress(0);

            const response = await uploadProfileImage(ftm?.ftm_id, file, (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgress(percent);
            });

            if (response?.status === 'Success') {
                setImageSrc(response.image_url);
                toast.success('Image uploaded successfully!');
                updateCurrentStep(4);
            } else {
                throw new Error('Upload failed');
            }
        } catch (error) {
            console.error(error);
            toast.error('Image upload failed.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <CardTemplate
            stepId={4}
            currentStep={step?.stepId}
            body={
                <div className="row">
                    <div className="col-12 col-sm-2">
                        <div
                            className="avatar avatar-xxl position-relative border-radius-md overflow-hidden"
                            style={{ width: 120, height: 120 }}
                        >
                            <img
                                src={imageSrc}
                                alt="profile"
                                className="w-100 h-100 object-fit-cover position-relative"
                                style={{ zIndex: 1 }}
                            />

                            {/* {step?.stepId === 3 && ( */}
                            <>
                                <button
                                    type="button"
                                    onClick={triggerFileInput}
                                    className="btn btn-sm btn-icon-only bg-gradient-dark position-absolute bottom-0 end-0 mb-1 me-1"
                                    style={{ zIndex: 2 }}
                                >
                                    <i className="material-icons text-xs mb-2">edit</i>
                                </button>
                                <input
                                    type="file"
                                    accept="image/*;capture=camera"
                                    // capture="user"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                            </>
                            {/* )} */}

                            {uploading && (
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                    style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', zIndex: 3 }}
                                >
                                    <div className={`spinner-border text-${theme.main}`} role="status" />
                                </div>
                            )}
                        </div>

                        {uploading && (
                            <div className="progress mt-2" style={{ height: 5 }}>
                                <div
                                    className={`progress-bar bg-gradient-${theme.main}`}
                                    role="progressbar"
                                    style={{ width: `${uploadProgress}%` }}
                                    aria-valuenow={uploadProgress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                />
                            </div>
                        )}
                    </div>

                    <div className="col-12 col-sm-10 text-start">
                        <p className="text-muted text-sm mb-2">Please take a passport style photo of yourself on a plain white background.</p>
                        <p className="text-muted text-sm mb-2">Head and shoulders with a smile, No Logos.</p>
                        <p className="text-muted text-sm">This image will be shared with customers whose jobs you accept so they know who to expect.</p>
                    </div>
                </div>
            }
        />
    );
};

export default ProfilePhoto;